/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { filterBy } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import moment from 'moment';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class GroupMaker extends Component {
  // Services
  @service
  options;

  @service
  paperToaster;

  @service
  router;

  @service
  session;

  @service
  store;

  GroupType = GroupType;

  name = 'New Group';

  label = 'New Group';

  @tracked
  showDialog = false;

  buttonText = 'Create group from these students';

  @tracked
  groupType = GroupType.GROUP;

  @action
  setGroupType(value) {
    this.groupType = value;
  }

  @tracked
  groupGrouping = null;

  @action
  setGroupGrouping(value) {
    this.groupGrouping = value;
  }

  @optionAlias('core:groups:groupings')
  groupings;

  @filterBy('groupings', 'value')
  cleanGroupings;

  @tracked
  group;

  @tracked
  newGroupLabel;

  @action
  setNewGroupLabel(value) {
    this.newGroupLabel = value;
  }

  @tracked
  newGroupName;

  @action
  setNewGroupName(value) {
    this.newGroupName = value;
  }

  @action
  openDialog() {
    this.newGroupName = this.name;
    this.newGroupLabel = this.label;
    this.groupType = GroupType.GROUP;
    this.showDialog = true;
  }

  @action
  closeDialog() {
    this.showDialog = false;
  }

  @action
  createGroup() {
    // Create the new group
    let group = this.store.createRecord('group', {
      name: this.newGroupName,
      label: this.newGroupLabel,
      type: this.groupType,
      schoolId: this.get('session.school'),
      year: moment().year(),
      grouping: this.get('groupGrouping.value'),
    });

    // Add current user as staff member
    group.get('staff').createFragment({
      personId: this.get('session.personId'),
      status: 1,
    });

    // Add the students
    this.learners.forEach(function (student) {
      group.get('learners').createFragment({
        personId: student.get('id'),
        status: 1,
      });
    });

    let toaster = this.paperToaster;
    group.save().then(
      () => {
        let router = this.router;
        this.showDialog = false;
        this.group = group;
        toaster.show(`Group "${this.newGroupName}" created successfully!`, {
          duration: 12000,
          position: 'top right',
          toastClass: 'success',
          action: {
            label: 'View Group',
            onClick: () => {
              router.transitionTo('group', group.id);
            },
          },
        });
      },
      () => {
        toaster.show(`Error creating group!`, {
          duration: 4000,
          position: 'top right',
          toastClass: 'warning',
        });
      },
    );
  }
}
